export const HTML2CANVAS_IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';

export const CHART_SVG_SELECTOR = 'svg.highcharts-root';
